var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMirror(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconoir:mirror"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6666 2.91699L8.16665 5.83366M11.6666 5.25033L7.29165 8.75033M11.6666 2.33366L11.6666 11.667C11.6666 11.9764 11.5437 12.2732 11.3249 12.4919C11.1061 12.7107 10.8094 12.8337 10.5 12.8337L3.49998 12.8337C3.19056 12.8337 2.89381 12.7107 2.67502 12.4919C2.45623 12.2732 2.33331 11.9764 2.33331 11.667L2.33331 2.33366C2.33331 2.02424 2.45623 1.72749 2.67502 1.5087C2.89381 1.28991 3.19056 1.16699 3.49998 1.16699L10.5 1.16699C10.8094 1.16699 11.1061 1.28991 11.3249 1.5087C11.5437 1.72749 11.6666 2.02424 11.6666 2.33366Z",
    stroke: "#090C0F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirror);
export default __webpack_public_path__ + "static/media/mirror.03ee2c793bc2ad80b4a3e8b5bb393e5a.svg";
export { ForwardRef as ReactComponent };